import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import FileInvocesPreviewArea from '../../../components/fileInvoicePreview'
import './style.scss'
const FileInvoicesPreviewPage = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <FileInvocesPreviewArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default FileInvoicesPreviewPage
/* FileInvocesPreviewArea */